The details of the hiring organization that uploaded the candidate and their profile.
